var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34446)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0955 32.4792L49.8292 19.2129L38.0188 32.3405L19.998 37.8384L29.9513 47.7916L24.8536 50.8187V60.5547L75.0812 110.782L110.596 74.7141L62.1628 26.2814L63.0955 32.4792Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4995_34446)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3359 45.3308L66.9043 48.9031C67.7575 49.5803 67.9895 50.771 67.4593 51.7402L62.6879 60.0032C62.3151 60.6866 61.5758 61.1257 60.7723 61.1257C60.4927 61.1257 60.2214 61.0738 59.9605 60.9724L54.5554 58.8021C53.4743 59.5725 52.4099 60.1917 51.3247 60.6825L50.5026 66.4189C50.3701 67.4875 49.4257 68.3076 48.3095 68.3076H38.7833C37.665 68.3076 36.7227 67.4875 36.5881 66.3983L35.768 60.6825C34.6476 60.1772 33.5645 59.5477 32.5332 58.8042L27.1426 60.9683C26.0036 61.3866 24.9019 60.9062 24.3945 59.9805L19.6438 51.761C19.1033 50.7711 19.3331 49.5803 20.1822 48.9073L24.7548 45.3329C24.6824 44.6329 24.6472 44.0262 24.6472 43.4566C24.6472 42.8871 24.6823 42.2803 24.7548 41.5824L20.1864 38.0101C19.3187 37.3225 19.0868 36.0903 19.6479 35.1418L24.4048 26.9119C24.908 25.9883 26.1195 25.5493 27.1323 25.9407L32.5374 28.111C33.6164 27.3428 34.6828 26.7215 35.768 26.2327L36.5902 20.4942C36.7228 19.4256 37.665 18.6055 38.7812 18.6055H48.3074C49.4236 18.6055 50.3679 19.4256 50.5026 20.5108L51.3227 26.2285C52.443 26.7318 53.5262 27.3613 54.5595 28.1068L59.9502 25.9427C61.0788 25.5265 62.1908 26.0028 62.6983 26.9306L67.449 35.1502C67.9895 36.1421 67.7576 37.3329 66.9085 38.0039L62.3359 41.5782C62.3959 42.1291 62.4435 42.7731 62.4435 43.4545C62.4435 44.1359 62.3938 44.7799 62.3359 45.3308ZM43.5425 52.9069C48.7617 52.9069 52.9928 48.6758 52.9928 43.4565C52.9928 38.2373 48.7617 34.0062 43.5425 34.0062C38.3232 34.0062 34.0921 38.2373 34.0921 43.4565C34.0921 48.6758 38.3232 52.9069 43.5425 52.9069Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4995_34446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7021,
    height: 49.7021,
    fill: "white",
    transform: "translate(18.6914 18.6055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.74b1b6be6a161cb4959e13fd31ea7bf9.svg";
export { ForwardRef as ReactComponent };